import React from 'react';
import { Row, Col, Select } from 'antd';

import OnTraccrCheckbox from '../../common/inputs/OnTraccrCheckbox';

const { Option } = Select;

export default ({
  integrationKey,
  helpText,
  setImportList,
  importList = new Set(),
  resetImportList,
  canImport = () => true,
  onViewTypeChanged,
  linkOptions = [],
  onLinkChanged,
  linkLabel = (option) => option.name,
  getValue = (linkValue) => linkValue,
}) => ({
  title:(
    <Row gutter={10} justify='center'>
      <OnTraccrCheckbox
        label="Import/Link"
        defaultChecked
        onChange={(checked) => {
          if(!checked) {
            return setImportList(new Set());
          }
          return resetImportList();
        }}
        value={importList?.size > 0}
        hoverNode={helpText}
        helpPlacement='left'
      />
    </Row>
  ),
  dataIndex:'import',
  key:'import',
  align:'center',
  fixed:'right',
  width:250,
  render:(_,record) => (
    <Row style={{ width: '100%'}} justify='end'>
      <Col>
        {
          record.viewType !== 'link' ?
          <Row style={{ height: 32}} align='middle'>
            <OnTraccrCheckbox
              disabled={!canImport(record)}
              value={importList.has(record[integrationKey]) && canImport(record)}
              onChange={(checked) => {
                if(checked) {
                  importList.add(record[integrationKey]);
                } else {
                  importList.delete(record[integrationKey]);
                }
                setImportList(new Set(importList));
              }}
            />
          </Row>
          :
          <Select
            value={getValue(record.linkValue)}
            key={record[integrationKey]}
            style={{ width: 125 }}
            showSearch
            allowClear
            onChange={(value, opt) => onLinkChanged(record,value,opt)}
            options={linkOptions.map((option) => ({ label: linkLabel(option), value: option.id }))}
            optionFilterProp='label'
            dropdownMatchSelectWidth={false}
            dropdownStyle={{
              flex:1,
              maxWidth:250,
            }}
          />

        }
      </Col>
      <Col>
        <Select
          style={{ width: 100 }}
          bordered={false}
          defaultValue={record.linkValue ? 'link' : 'import'}
          onChange={(type) => onViewTypeChanged(record,type)}
        >
          <Option value='import'>Import</Option>
          <Option value='link'>Link</Option>
        </Select>
      </Col>
    </Row>
  ),
});
